module.exports = __webpack_public_path__ + "img/uib_logo.0f50eb8d.png";